<template>
    <v-col class="ml-4">
        <span
            v-for="productGroupItem in selectedProductGroupItems"
            :key="productGroupItem.name" >
          <v-row style="justify-content: right">
            <v-select class="ml-1"
                      outlined
                      v-if="!selectedProducts[productGroupItem.name]"
                      label="Add Product Group"
                      :items="displayProductGroups.filter(x => !selectedProductGroupItems.find(item => item.name === x.name))"
                      :item-text="productGroup => productGroup.name"
                      :item-value="productGroup => productGroup.name"
                      no-data-text="Loading Products..."
                      :value="productGroupItem.name"
                      @input="setGroup"
                      :loading="loadingGroup"
                      dense
            />
            <v-select class="ml-1"
                      outlined
                      v-else
                      :items="displayProductGroups"
                      readonly
                      :item-text="productGroup => productGroup.name"
                      :item-value="productGroup => productGroup.name"
                      :value="productGroupItem.name"
                      :loading="loadingGroup"
                      clearable
                      @click:clear="removeProductsUnderGroup(productGroupItem.name)"
                      dense
            />
          </v-row>
          <span :key="componentKey">
              <v-row v-if="selectedProducts[productGroupItem.name]" style="justify-content: right; flex-wrap: wrap" >
                <v-text-field class="ml-1"
                              style="min-width: 100px; max-width: 120px"
                              outlined
                              :label="product.name"
                              placeholder="0"
                              type="number"
                              v-for="product in displayProducts[productGroupItem.name]"
                              :key="product.uuid"
                              @keydown="preventDecimalKeys"
                              @input="handleQuantityInput(productGroupItem.name, product.name, $event)"
                              @paste="handleQuantityInput(productGroupItem.name, product.name, $event)"
                              v-model="selectedProducts[productGroupItem.name][product.name]['quantity']"
                              :loading="loadingProduct[productGroupItem.name]"
                              :error="hasInputError(productGroupItem.name, product.name)"
                              :error-messages="getErrorMessage(productGroupItem.name, product.name)"
                              dense
                />
              </v-row>
        </span>
      </span>
    </v-col>
</template>

<script>
    export default {
        name: "SelectProducts",
        props: {
          clearable: Boolean,
          small: Boolean,
          hideDetails: String,
          chips: Boolean,
          assetType: Number
        },
        data: () => ({
          displayProductGroups: [],
          displayProducts: [],
          selectedProductGroups: [],
          selectedProductGroupItems: [{name: ''}],
          selectedProducts: [],
          state: 'display',
          search: '',
          awaitingSearch: false,
          loadingGroup: false,
          loadingProduct: [false],
          componentKey: 0,
          inputErrors: {}
        }),
        methods: {
          forceRerender() {
            this.componentKey += 1;
          },
          fetchProductGroups() {
            this.loadingGroup = true
            const url = '/products'
            this.$axios.get(url, {params: {}}).then(({data}) => {
              if (this.assetType) {
                let onlyAsset = [];
                data.forEach(item => {
                  if (this.assetType === 7000 && item.name.includes('Goldback')) {
                    onlyAsset.push(item);
                  } else if (this.assetType === 3373 && item.name.includes('Gold Coin')) {
                      onlyAsset.push(item);
                  } else if (this.assetType === 3374 && item.name.includes('Silver Coin')) {
                      onlyAsset.push(item);
                  }
                }
                );
                this.displayProductGroups = onlyAsset;
              }
              else this.displayProductGroups = data;
              this.loadingGroup = false;
            })
            .catch(({response}) => {
              alert(response)
              this.loadingGroup = false
            })
          },
          setGroup(value) {
            this.fetchProducts(value)
          },
          fetchProducts(groupName) {
            if (!groupName) {
              return
            }
            this.loadingProduct[groupName] = true
            const url = '/products?groupName=' + groupName
            const params = this.inactiveHeaders ? {showInactive: 1} : {showInactive: 0}
            this.$axios.get(url, {params: params}).then(({data}) => {
              this.selectedProducts[groupName] = []
              data.forEach(item => this.selectedProducts[groupName][item.name] = item)
              this.displayProducts[groupName] = {...data}
              this.selectedProductGroupItems.pop()
              this.selectedProductGroupItems.push({name: groupName})
              this.selectedProductGroupItems.push({name: ''})
              this.forceRerender()
              this.loadingProduct[groupName] = false
            })
            .catch(({response}) => {
              alert(response)
              this.loadingProduct[groupName] = false
            })
          },
          removeProductsUnderGroup(groupName) {
            this.loadingGroup = true
            delete this.selectedProducts[groupName];
            this.selectedProductGroupItems = this.selectedProductGroupItems.filter(function(x) { return x.name !== groupName })
            this.forceRerender()
            this.emitOut()
            this.loadingGroup = false
          },
          preventDecimalKeys(event) {
            // Prevent decimal point, minus, plus, and 'e' keys
            if (event.key === '.' || event.key === '-' || event.key === '+' || 
                event.key === 'e' || event.key === 'E') {
              event.preventDefault();
              this.showInputError(event.target, 'Only whole numbers allowed');
              return false;
            }
            
            // Allow: backspace, delete, tab, escape, enter, arrow keys
            if ([8, 9, 27, 13, 37, 38, 39, 40, 46].indexOf(event.keyCode) !== -1 ||
                // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
                (event.ctrlKey && [65, 67, 86, 88].indexOf(event.keyCode) !== -1)) {
              return true;
            }
            
            // Ensure that it's a number (0-9)
            if ((event.keyCode < 48 || event.keyCode > 57) && 
                (event.keyCode < 96 || event.keyCode > 105)) {
              event.preventDefault();
              this.showInputError(event.target, 'Only numbers allowed');
              return false;
            }
          },
          showInputError(inputElement, message) {
            // Find the product info from the input element
            const label = inputElement.getAttribute('aria-label') || inputElement.labels?.[0]?.textContent;
            if (label) {
              // Flash error temporarily
              this.$set(this.inputErrors, label, message);
              setTimeout(() => {
                this.$delete(this.inputErrors, label);
              }, 2000);
            }
          },
          hasInputError(groupName, productName) {
            const key = `${groupName}-${productName}`;
            return !!this.inputErrors[key];
          },
          getErrorMessage(groupName, productName) {
            const key = `${groupName}-${productName}`;
            return this.inputErrors[key] || '';
          },
          handleQuantityInput(groupName, productName, event) {
            let value = event.target ? event.target.value : event;
            const originalValue = value;
            const key = `${groupName}-${productName}`;
            
            // Check if the original value contains invalid characters (but allow empty)
            if (String(originalValue).trim() !== '' && String(originalValue).match(/[^0-9]/)) {
              this.$set(this.inputErrors, key, 'Only whole numbers allowed');
              setTimeout(() => {
                this.$delete(this.inputErrors, key);
              }, 2000);
            } else {
              // Clear any existing error
              this.$delete(this.inputErrors, key);
            }
            
            // Remove all non-digit characters (including decimals, letters, symbols)
            let cleanValue = String(value).replace(/[^0-9]/g, '');
            
            // Remove leading zeros (except for the value "0" itself)
            if (cleanValue.length > 1) {
              cleanValue = cleanValue.replace(/^0+/, '');
              // If all zeros were removed, default to "0"
              if (cleanValue === '') {
                cleanValue = '0';
              }
            }
            
            // Convert to integer, default to 0 if empty
            let intValue = cleanValue === '' ? 0 : parseInt(cleanValue, 10);
            
            // Ensure not negative
            intValue = Math.max(0, intValue);
            
            // Update the model with the integer value
            if (this.selectedProducts[groupName] && this.selectedProducts[groupName][productName]) {
              this.selectedProducts[groupName][productName].quantity = intValue;
            }
            
            // Use nextTick to update the input after Vue processes the model change
            this.$nextTick(() => {
              if (event.target && event.target.value !== intValue.toString()) {
                event.target.value = intValue.toString();
              }
            });
            
            // Emit the updated data
            this.emitOut();
          },
          emitOut() {
            // Convert quantity values to integers before emitting
            const convertedProducts = {};
            Object.keys(this.selectedProducts).forEach(groupName => {
              if (this.selectedProducts[groupName]) {
                convertedProducts[groupName] = {};
                Object.keys(this.selectedProducts[groupName]).forEach(productName => {
                  convertedProducts[groupName][productName] = {
                    ...this.selectedProducts[groupName][productName]
                  };
                  // Convert quantity to integer, default to 0 if not a valid number
                  if (convertedProducts[groupName][productName].quantity !== undefined) {
                    const quantity = parseInt(convertedProducts[groupName][productName].quantity) || 0;
                    convertedProducts[groupName][productName].quantity = quantity;
                  }
                });
              }
            });
            this.$emit('productsSelected', convertedProducts);
          }
        },
      mounted() {
        this.fetchProductGroups();
      },
      computed: {
        },
        watch: {
        },
    }
</script>

<style scoped>

</style>